import { Controller } from 'stimulus';

class VideoBlockController extends Controller {
  connect() {
    this.isPlaying = false;

    const videoElement = this.createVideoElement();

    this.wrapperTarget.appendChild(videoElement);
  }

  scrollHitHandler(scrollElementObject, type) {
    if (type === 'enter' && !this.isPlaying) {
      this.togglePlay(true);
    } else if (type === 'exit' && this.isPlaying) {
      this.togglePlay(false);
    }
  }

  togglePlay(state) {
    try {
      this.isPlaying = state;
      this.videoTarget[state ? 'play' : 'pause']();
    } catch (err) {
      //
    }
  }

  createVideoElement() {
    const hdUrl = this.data.get('hd-url');
    const sdUrl = this.data.get('sd-url');

    let source = hdUrl;

    if (typeof sdUrl !== 'undefined' && window.innerWidth < 1024) {
      source = sdUrl;
    }

    const videoElement = document.createElement('video');
    const sourceElement = document.createElement('source');

    sourceElement.type = 'video/mp4';
    sourceElement.src = source;

    videoElement.appendChild(sourceElement);

    videoElement.className = 'absolute-center img-fit';
    videoElement.muted = true;
    videoElement.loop = true;
    videoElement.setAttribute('playsinline', '');
    videoElement.setAttribute('data-target', 'video-block.video');

    return videoElement;
  }
}

VideoBlockController.targets = [
  'wrapper',
  'video',
];

export default VideoBlockController;
